import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdHistory, MdPlayArrow, MdDeleteOutline, MdInfoOutline } from 'react-icons/md';

const IncompleteForms = () => {
  const navigate = useNavigate();
  const [incompleteForms, setIncompleteForms] = useState([]);

  useEffect(() => {
    loadIncompleteForms();
  }, []);

  const loadIncompleteForms = () => {
    const forms = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith('formStatus_')) {
        try {
          const formStatus = JSON.parse(sessionStorage.getItem(key));
          if (formStatus && formStatus.status === 'incomplete') {
            forms.push(formStatus);
          }
        } catch (error) {
          console.error('Error parsing form status:', error);
        }
      }
    }
    forms.sort((a, b) => new Date(b.lastSaved) - new Date(a.lastSaved));
    setIncompleteForms(forms);
  };

  const handleContinueForm = (formStatus) => {
    navigate(formStatus.continueUrl);
  };

  const handleRemoveForm = (uhid_no, formType) => {
    const key = `formStatus_${formType}_${uhid_no}`;
    sessionStorage.removeItem(key);
    const formDataKey = `${formType}Form_${uhid_no}`;
    sessionStorage.removeItem(formDataKey);
    loadIncompleteForms();
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  if (incompleteForms.length === 0) return null;

  return (
    <div className="mb-10 animate-fade-in">
      <div className="flex items-center space-x-3 mb-6 px-2">
        <div className="p-2 bg-amber-100 text-amber-600 rounded-lg">
          <MdInfoOutline className="w-6 h-6" />
        </div>
        <div>
          <h2 className="text-lg font-black text-slate-800 tracking-tight">Pending Submissions</h2>
          <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">You have {incompleteForms.length} draft forms</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 px-2">
        {incompleteForms.map((form, index) => (
          <div
            key={index}
            className="group bg-white rounded-3xl p-5 border border-slate-100 shadow-sm hover:shadow-xl hover:shadow-slate-200/50 transition-all duration-300 relative overflow-hidden"
          >
            {/* Background Decoration */}
            <div className="absolute -right-4 -top-4 w-16 h-16 bg-slate-50 rounded-full transition-transform group-hover:scale-150 duration-500"></div>

            <div className="relative z-10">
              <div className="flex justify-between items-start mb-4">
                <div className="p-2.5 bg-teal-50 text-teal-600 rounded-xl group-hover:bg-teal-600 group-hover:text-white transition-colors duration-300">
                  <MdHistory className="w-6 h-6" />
                </div>
                <button
                  onClick={() => handleRemoveForm(form.uhid_no, form.formType || form.formName.split(' ')[0])}
                  className="p-2 text-slate-300 hover:text-red-500 hover:bg-red-50 rounded-lg transition-all"
                  title="Discard Draft"
                >
                  <MdDeleteOutline className="w-5 h-5" />
                </button>
              </div>

              <h3 className="text-sm font-black text-slate-800 mb-1 group-hover:text-teal-700 transition-colors">
                {form.formName}
              </h3>

              <div className="space-y-2 mb-6">
                <div className="flex justify-between items-center text-[10px] font-bold">
                  <span className="text-slate-400 uppercase tracking-tighter">UHID NUMBER</span>
                  <span className="text-slate-700">{form.uhid_no}</span>
                </div>
                <div className="flex justify-between items-center text-[10px] font-bold">
                  <span className="text-slate-400 uppercase tracking-tighter">LAST UPDATED</span>
                  <span className="text-slate-700">{formatDate(form.lastSaved)}</span>
                </div>
              </div>

              <button
                onClick={() => handleContinueForm(form)}
                className="w-full flex items-center justify-center space-x-2 py-3 bg-slate-900 text-white rounded-2xl font-bold text-xs hover:bg-teal-600 shadow-lg shadow-slate-200 hover:shadow-teal-100 transition-all active:scale-95"
              >
                <MdPlayArrow className="w-4 h-4" />
                <span>Resume Drafting</span>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IncompleteForms;
